import {
  UserManager,
  WebStorageStateStore,
  type UserManagerSettings,
} from "oidc-client-ts";
import type { PortalConfig } from "./portal-config";

/** Absolute URL of the silent-callback page (sibling of the main app URL). */
export function silentRenewPageUrl(locationHref: string): string {
  return new URL("silent-renew.html", locationHref).href;
}

export function buildUserManagerSettings(
  cfg: PortalConfig,
  locationHref: string,
  options: { automaticSilentRenew: boolean },
): UserManagerSettings {
  return {
    authority: cfg.authority,
    client_id: cfg.clientId,
    redirect_uri: cfg.redirectUri,
    silent_redirect_uri: silentRenewPageUrl(locationHref),
    post_logout_redirect_uri: cfg.redirectUri,
    response_type: "code",
    scope: "openid profile email",
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: options.automaticSilentRenew,
  };
}

export function createUserManager(
  cfg: PortalConfig,
  locationHref: string,
  options: { automaticSilentRenew: boolean },
): UserManager {
  return new UserManager(buildUserManagerSettings(cfg, locationHref, options));
}
